(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clair-crosssell"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ccx').forEach(function (root) {
  root.querySelectorAll('.ccx__row').forEach(function (row) {
    var per = parseInt(row.dataset.per || '2', 10);
    var grid = row.querySelector('.ccx__grid'); if (!grid) return;
    var cards = Array.prototype.slice.call(grid.children);
    var byCat = {};
    cards.forEach(function (c) { var k = c.dataset.cat || 'x'; (byCat[k] = byCat[k] || []).push(c); });
    var picks = [];
    Object.keys(byCat).forEach(function (k) { var a = byCat[k]; for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } picks.push(a.slice(0, per)); });
    cards.forEach(function (c) { c.style.display = 'none'; });
    var idx = 0, more = true;
    while (more) { more = false; picks.forEach(function (p) { if (p[idx]) { p[idx].style.display = ''; grid.appendChild(p[idx]); more = true; } }); idx++; }
  });
  // The cart surfaces have to move together (CLAUDE.md trap 10). cart_type is "drawer" on this
  // store, so this resolves to <cart-drawer>; product-form.js resolves the same way.
  var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  root.querySelectorAll('button.ccx__add').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.disabled) return; b.disabled = true;
      // Attribution: this grid is the bags-and-accessories tail, and a quick-add here is otherwise
      // indistinguishable from any other add. Underscore-prefixed, so it stays out of the customer's
      // cart and confirmation mail but comes back in the Admin API. Same pattern as _Quantity source.
      var card = b.closest('.ccx__card');
      var col = (card && card.dataset.col) || '';
      var payload = { id: b.dataset.id, quantity: 1, properties: { '_Source': col ? 'crosssell:' + col : 'crosssell' } };
      // Ask for the same sections product-form.js asks for, so the bag count and the drawer's
      // contents are rebuilt from the server rather than left stale. Before this, the only refresh
      // signal was a 'cart:refresh' event that nothing in the theme listens for.
      if (cart) { payload.sections = cart.getSectionsToRender().map(function (s) { return s.id; }); payload.sections_url = window.location.pathname; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (cart && response && response.sections) { cart.setActiveElement(b); cart.renderContents(response); }
          b.textContent = '✓'; b.classList.add('is-added'); var st = root.querySelector('.ccx__status'); if (st) { st.textContent = root.dataset.added || 'Added to cart'; } document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); setTimeout(function () { b.textContent = b.dataset.label || 'Add'; b.classList.remove('is-added'); b.disabled = false; }, 1600); })
        .catch(function () { b.disabled = false; });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clair-home"] && !Shopify.designMode) return;
  try {
    
/* Below-the-fold background bands ([data-lazybg]) get their image when they come within
   600px of the viewport. Without IntersectionObserver they simply all load. */
(function () {
  var els = document.querySelectorAll('[data-lazybg]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { Array.prototype.forEach.call(els, function (el) { el.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '600px 0px' });
  Array.prototype.forEach.call(els, function (el) { io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clair-topbar"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.ctb__rot').forEach(function (rot) {
    var items = rot.querySelectorAll('.ctb__rot-item');
    if (!items.length) return;
    items[0].classList.add('is-active');
    if (items.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0, paused = false;
    var ms = (parseFloat(rot.getAttribute('data-speed')) || 5) * 1000;
    function step() {
      if (paused || document.hidden) return;   // don't cycle in a background tab
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }
    setInterval(step, ms);
    function hold(on) { paused = on; rot.classList.toggle('is-paused', on); }
    rot.addEventListener('mouseenter', function () { hold(true); });
    rot.addEventListener('mouseleave', function () { hold(false); });
    rot.addEventListener('focusin',   function () { hold(true); });
    rot.addEventListener('focusout',  function () { hold(false); });
  });
})();

/* Language suggestion. Reads the visitor's own browser preference rather than
   their location: geography is a poor proxy for language, and Shopify has
   already set the country anyway. Matches on the PRIMARY subtag so fr-CA and
   fr-FR both find "fr". Switching reuses the localization form that is already
   on the page, so the market/return_to handling stays Shopify's. Once
   dismissed, it stays dismissed. */
(function () {
  var bar = document.querySelector('[data-ctb-sugg]');
  var data = document.querySelector('[data-ctb-langs]');
  var form = document.getElementById('ctb-lang');
  if (!bar || !data || !form) return;

  var sel = form.querySelector('select[name="language_code"]');
  if (!sel) return;
  var current = sel.value;

  var langs;
  try { langs = JSON.parse(data.textContent || '[]'); } catch (e) { return; }
  if (!langs.length) return;

  var KEY = 'lba:langsugg';
  try { if (localStorage.getItem(KEY) === '1') return; } catch (e) {}

  var prefs = (navigator.languages && navigator.languages.length)
    ? navigator.languages : [navigator.language || ''];

  var want = null;
  for (var i = 0; i < prefs.length && !want; i++) {
    var tag = String(prefs[i] || '').toLowerCase().split('-')[0];
    if (!tag) continue;
    for (var j = 0; j < langs.length; j++) {
      if (String(langs[j].code).toLowerCase().split('-')[0] === tag) { want = langs[j]; break; }
    }
  }
  // Nothing to say if we have no match, or they are already reading it.
  if (!want) return;
  if (String(want.code).toLowerCase() === String(current).toLowerCase()) return;

  bar.querySelector('[data-sugg-txt]').textContent = want.msg;
  var go = bar.querySelector('[data-sugg-go]');
  go.textContent = want.cta;
  go.setAttribute('lang', want.code);
  bar.querySelector('[data-sugg-txt]').setAttribute('lang', want.code);
  bar.hidden = false;

  go.addEventListener('click', function () {
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
    sel.value = want.code;
    form.submit();
  });
  bar.querySelector('[data-sugg-x]').addEventListener('click', function () {
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
    bar.hidden = true;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fade-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.fade'); if (!root) return;
  var mount = root.querySelector('.fade__mount');
  var L = {}; try { L = JSON.parse(root.querySelector('[data-fade-labels]').textContent); } catch (e) {}
  var discount = parseInt(root.dataset.discount, 10) || 10;
  var money = function (c) { return '€' + (c / 100).toFixed(2); };
  // A hand-dyed skein is three colours, not one. lba.palette carries the real
  // stops; lba.hex is the flattened average. Use the stops wherever a swatch
  // stands for ONE skein — the picker dots and the summary chips. The strip
  // deliberately keeps one colour per skein: its job is the skein-to-skein
  // fade, and intra-skein variation makes that progression harder to judge.
  var skein = function (c) {
    return c.palette && c.palette.length > 1
      ? 'linear-gradient(135deg,' + c.palette.join(',') + ')'
      : c.color;
  };
  fetch(root.dataset.fadeUrl).then(function (r) { return r.json(); }).then(function (data) {
    var bases = (data && data.bases) || [];
    if (!bases.length) { mount.innerHTML = '<p style="text-align:center">No bases available yet.</p>'; return; }
    var s = { base: 0, count: 4, active: 0, slots: [0, 1, 2, 3, 4] };
    function fill() { var cw = bases[s.base].colourways; while (s.slots.length < s.count) s.slots.push(s.slots.length % cw.length); s.slots = s.slots.map(function (i) { return i % cw.length; }); if (s.active >= s.count) s.active = s.count - 1; }
    function render() {
      fill();
      var b = bases[s.base], cw = b.colourways;
      var chosen = s.slots.slice(0, s.count).map(function (i) { return cw[i]; });
      var grad = 'linear-gradient(90deg,' + chosen.map(function (c) { return c.color; }).join(',') + ')';
      var segs = chosen.map(function (c, i) { return '<button class="fade__seg' + (s.active === i ? ' is-active' : '') + '" data-slot="' + i + '" title="' + c.name + '"><span>' + (i + 1) + '</span></button>'; }).join('');
      var baseBtns = bases.map(function (x, i) { return '<button class="fade__base' + (i === s.base ? ' is-on' : '') + '" data-base="' + i + '">' + x.title + '</button>'; }).join('');
      var counts = [3, 4, 5].map(function (n) { return '<button class="fade__count' + (n === s.count ? ' is-on' : '') + '" data-count="' + n + '">' + n + '</button>'; }).join('');
      var dots = cw.map(function (c, i) { return '<button class="fade__dot' + (s.slots[s.active] === i ? ' is-on' : '') + '" data-colour="' + i + '" title="' + c.name + '" style="background:' + skein(c) + '"></button>'; }).join('');
      var list = chosen.map(function (c, i) { return '<li><span class="fade__chip" style="background:' + skein(c) + '"></span>' + (i + 1) + '. ' + c.name + '</li>'; }).join('');
      var unit = b.price, gross = unit * s.count, save = Math.round(gross * discount / 100), total = gross - save;
      mount.innerHTML =
        '<div class="fade__strip" style="background:' + grad + '">' + segs + '</div>' +
        '<div class="fade__cols"><div class="fade__panel">' +
        '<p class="fade__label">' + (L.base || 'Base') + '</p><div class="fade__bases">' + baseBtns + '</div>' +
        '<p class="fade__label">' + (L.count || 'How many skeins?') + '</p><div class="fade__counts">' + counts + '</div>' +
        '<p class="fade__label">' + (L.pick || 'Tap a skein, then pick a color') + '</p><div class="fade__grid">' + dots + '</div>' +
        '</div><aside class="fade__sum"><h3>' + (L.your || 'Your dégradé') + '</h3><ul class="fade__list">' + list + '</ul>' +
        '<div class="fade__line"><span>' + s.count + ' × ' + b.title + '</span><span>' + money(gross) + '</span></div>' +
        '<div class="fade__line fade__line--save"><span>' + (L.saving || 'Dégradé saving') + ' (' + discount + '%)</span><span>−' + money(save) + '</span></div>' +
        '<div class="fade__total"><span>' + (L.total || 'Total') + '</span><span>' + money(total) + '</span></div>' +
        '<button class="fade__add">' + (L.add || 'Add Dégradé to cart') + '</button>' +
        '<p class="fade__note">' + (L.note || 'Dyed to order together, ships in 3–4 weeks') + '</p>' +
        '</aside></div>';
    }
    mount.addEventListener('click', function (e) {
      var t = e.target.closest('[data-base],[data-count],[data-slot],[data-colour],.fade__add'); if (!t) return;
      if (t.dataset.base !== undefined) { s.base = +t.dataset.base; s.slots = [0, 1, 2, 3, 4]; s.active = 0; render(); }
      else if (t.dataset.count !== undefined) { s.count = +t.dataset.count; render(); }
      else if (t.dataset.slot !== undefined) { s.active = +t.dataset.slot; render(); }
      else if (t.dataset.colour !== undefined) { s.slots[s.active] = +t.dataset.colour; if (s.active < s.count - 1) s.active++; render(); }
      else if (t.classList.contains('fade__add')) {
        var b = bases[s.base], cw = b.colourways;
        var items = s.slots.slice(0, s.count).map(function (i) { return { id: cw[i].id, quantity: 1, properties: { 'Dégradé': b.title } }; });
        t.disabled = true; t.textContent = (L.adding || 'Adding…');
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { return r.json(); }).then(function () { window.location = '/cart'; })
          .catch(function () { t.disabled = false; t.textContent = (L.add || 'Add'); });
      }
    });
    render();
  }).catch(function () { mount.innerHTML = '<p style="text-align:center">Could not load the dégradé builder.</p>'; });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-clair"] && !Shopify.designMode) return;
  try {
    
/* Facet panels.

   `name="clair-facet"` makes <details> siblings mutually exclusive, but only in
   Chrome 120+, Safari 17.2+ and Firefox 130+. Older browsers ignore it and leave
   both panels hanging open — which is the reported bug. The first handler below
   is that fallback, and it is skipped where the browser does it natively.

   The second handler closes an open panel when you click outside it. A dropdown
   that can only be dismissed by clicking its own summary feels stuck. */
(function () {
  var facets = Array.prototype.slice.call(document.querySelectorAll('details.cc__facet'));
  if (!facets.length) return;
  var native = 'name' in document.createElement('details');
  if (!native) {
    facets.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        facets.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }
  document.addEventListener('click', function (e) {
    // Only the desktop dropdowns; on a phone the groups are an accordion in
    // flow and a tap elsewhere should not fold one away.
    if (window.matchMedia('(max-width: 749px)').matches) return;
    facets.forEach(function (d) {
      if (d.open && !d.contains(e.target)) d.open = false;
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    facets.forEach(function (d) { d.open = false; });
  });
})();

/* Phone filter drawer. The wrapper is `open` in the markup so that without JS
   every group is simply visible; on a phone it starts closed (inline script in
   the markup, before first paint) and "Show N results" closes it again and
   hands focus back to the toggle. Crossing 750px re-opens it so the desktop
   pills are never hidden. */
(function () {
  var mf = document.querySelector('[data-cc-mf]');
  if (!mf) return;
  var phone = window.matchMedia('(max-width: 749px)');
  function sync() { mf.open = !phone.matches; }
  if (phone.addEventListener) { phone.addEventListener('change', sync); } else if (phone.addListener) { phone.addListener(sync); }
  var done = mf.querySelector('[data-cc-mf-done]');
  if (done) {
    done.addEventListener('click', function () {
      mf.open = false;
      var s = mf.querySelector('summary');
      if (s) s.focus();
    });
  }
})();

  /* Sort control. The form works on its own; this just submits it on change so
     the shopper does not have to press a button. */
  document.querySelectorAll('[data-cc-sortform]').forEach(function (form) {
    var sel = form.querySelector('[data-cc-sort]');
    if (!sel) return;
    sel.addEventListener('change', function () { form.submit(); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-clair"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.clair').forEach(function (root) {
  var hero = root.querySelector('.clair__hero');
  var EX = {};
  var exUrl = root.dataset.exUrl, shownTpl = root.dataset.shownTpl || 'Shown on [base]';
  var overlay = root.querySelector('.clair__exoverlay');
  // Selected-colourway line. Writes the name and the stock figure separately:
  // the previous code assigned textContent on the whole <p>, which deleted the
  // pill element on the first swatch click and never brought it back.
  var STOCK_TPL = root.dataset.stockTpl || '';
  // Dye-to-order state. Two triggers, and both must show the caveat: the
  // variant is sold out, or the quantity asked for exceeds what is in stock.
  // The second matters because the whole line is dyed fresh — if there are 8
  // and someone wants 10, all 10 are dyed and the 8 stay on the shelf — so a
  // customer ordering over stock is waiting 7-10 days even though the page
  // said "in stock".
  var dtoNote = root.querySelector('[data-dto-note]');
  var dtoOver = root.querySelector('[data-dto-over]');
  var dtoFinal = root.querySelector('[data-dto-final]');   // the no-returns line: same condition as the property below
  var addLbl  = root.querySelector('.clair__add span[data-plain]');
  var dtoSoldOut = false;
  var dyeOn = root.dataset.dyeOn !== 'false';
  var dtoProp = root.querySelector('[data-dto-prop]');
  function markLine(isCustom) {
    // A DISABLED input is not submitted, so the property only reaches the order
    // when the line really is a custom dye. That matters: a stray property on a
    // normal line would send the atelier chasing an order that needs nothing.
    if (dtoFinal) dtoFinal.hidden = !isCustom;
    if (!dtoProp) return;
    dtoProp.disabled = !isCustom;
    dtoProp.value = isCustom ? (root.dataset.dtoLine || 'Yes') : '';
  }
  function setDto(soldOut) {
    if (!dyeOn) soldOut = false;
    dtoSoldOut = soldOut;
    if (dtoNote) dtoNote.hidden = !soldOut;
    if (addLbl && addLbl.dataset.dto) {
      addLbl.textContent = soldOut ? addLbl.dataset.dto
                                   : (addLbl.dataset.plain || addLbl.textContent);
    }
    refreshOver();
  }
  // The SELECTED variant's own facts. Dyeability is per variant (policy CONTINUE), not per page:
  // a colourway page can hold a base that is switched off beside bases that are not (Anne,
  // 2026-10-13: Haku / Felix at DENY). The base matrix writes root.dataset.sel*; a plain swatch
  // page has only the selected dot.
  function selFacts() {
    var dot = root.querySelector('.clair__dot.is-sel');
    var ds = root.dataset;
    if (ds.selQty != null) return { dye: ds.selDye !== 'false', qty: parseInt(ds.selQty || '0', 10), trk: ds.selTrk === 'true' };
    if (dot) return { dye: dot.dataset.dyeable !== 'false', qty: parseInt(dot.dataset.qty || '0', 10), trk: dot.dataset.trk === 'true' };
    return { dye: dtoProp ? dtoProp.dataset.dyeable === 'true' : false, qty: 0, trk: false };
  }
  function refreshOver() {
    var qEl = root.querySelector('.clair__qty, input[name="quantity"]');
    var want = qEl ? (parseInt(qEl.value, 10) || 1) : 1;
    var f = selFacts();
    var canDye = dyeOn && f.dye;
    var have = f.qty;
    // A variant that cannot be dyed stops at its shelf. Shopify refuses an add above stock on a
    // DENY variant, so the page used to promise "dyed to order" and then add nothing. Hold the
    // quantity at what is there; the stock pill already says how many that is.
    if (!canDye && f.trk && have > 0 && want > have && qEl) {
      qEl.value = have;
      qEl.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }
    if (!dtoOver) { markLine(dyeOn && dtoSoldOut); return; }
    var over = canDye && have > 0 && want > have;
    dtoOver.hidden = dtoSoldOut || !over;
    markLine(dyeOn && (dtoSoldOut || over));
  }
  // The swatch handler is not the only way onto this page. A link straight to a
  // sold-out colourway renders the Dye-to-order button from Liquid but fires no
  // click, so without this the property stayed disabled and the order reached
  // the atelier with no flag at all — and on a base-only product with no colour
  // swatches there was no way to recover, ever. Initialise from what Liquid
  // already worked out.
  setDto(dtoProp ? dtoProp.dataset.dtoInit === 'true' : false);
  // The base/colour matrix lives in its own IIFE further down and has to be able
  // to drive the same state rather than fight it.
  root.__clairSetDto = setDto;
  root.__clairRefreshOver = refreshOver;

  root.addEventListener('input', function (e) {
    if (e.target && e.target.matches('input[name="quantity"], .clair__qty')) refreshOver();
  });
  root.addEventListener('click', function (e) {
    if (e.target && e.target.closest('.clair__step')) setTimeout(refreshOver, 0);
  });

  function setSelected(title, avail, qty, trk) {
    var line = root.querySelector('[data-selected]'); if (!line) return;
    var nameEl = line.querySelector('[data-selected-name]');
    var pill = line.querySelector('[data-selected-stock]');
    if (nameEl && title) nameEl.textContent = title;
    if (!pill) return;
    // avail here means IN STOCK (the swatch's data-available now reports stock,
    // not orderability). Zero or below is orderable but must not read "In stock".
    if (!avail || (trk && qty <= 0)) {
      pill.textContent = root.dataset.dtoTpl || root.dataset.soldTpl || '';
      pill.setAttribute('data-dto', ''); return;
    }
    pill.removeAttribute('data-dto');
    // Same rule as the Liquid pill: exact up to the cap, then "More than N".
    var cap = parseInt(root.dataset.stockCap || '10', 10);
    pill.textContent = (trk && qty > 0 && STOCK_TPL)
      ? (qty > cap ? (root.dataset.stockMoreTpl || '') : STOCK_TPL.replace('[n]', qty))
      : (root.dataset.instockTpl || '');
  }

  function applyExample(cw, ph, img) {
    if (hero) hero.removeAttribute('srcset');
    var hw = (window.innerWidth && window.innerWidth < 750) ? 800 : 1400;
    var ex = (ph && cw) ? EX[cw] : null;
    if (ex && hero) { var u = ex.u + (ex.u.indexOf('?') > -1 ? '&' : '?') + 'width=' + hw; hero.src = u; if (overlay) { overlay.textContent = shownTpl.replace('[base]', ex.b); overlay.hidden = false; } }
    else { if (img && hero) { hero.src = img.replace(/([?&]width=)\d+/, '$1' + hw); } if (overlay) overlay.hidden = true; }
  }
  if (exUrl) {
    fetch(exUrl).then(function (r) { return r.json(); }).then(function (j) {
      EX = j || {};
      root.querySelectorAll('.clair__dot').forEach(function (d) {
        if (d.dataset.ph === 'true' && EX[d.dataset.cw]) {
          // Paint the borrowed photo on the TILE, not the button. The button is
          // now a wrapper holding the tile and the name; a background on it
          // renders behind both, so the borrowed image bled out under the
          // caption and made the name unreadable.
          var u = EX[d.dataset.cw].u;
          var tgt = d.querySelector('.clair__tile') || d;
          tgt.style.backgroundImage = 'url(' + u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=200)';
          var w = EX[d.dataset.cw].w; if (w >= 1590 && w <= 1610) tgt.classList.add('clair__tile--studio');
          tgt.classList.add('is-loaded');            // .clair__tile--studio only frames once loaded
          tgt.style.backgroundSize = 'cover';        // the !important studio rule wins over this when it applies
          tgt.style.backgroundPosition = 'center';
        }
      });
      var selDot = root.querySelector('.clair__dot.is-sel');
      if (selDot) applyExample(selDot.dataset.cw, selDot.dataset.ph === 'true', selDot.dataset.img);
    }).catch(function () {});
  }
  root.querySelectorAll('.clair__vt').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('.clair__vt').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var v = btn.dataset.view;
      var src = hero ? hero.dataset[v] : '';
      var noimg = root.querySelector('.clair__noimg');
      if (v === 'knit' && !src) { if (noimg) noimg.hidden = false; }
      else { if (hero && src) { hero.removeAttribute('srcset'); hero.src = src; } if (noimg) noimg.hidden = true; }
    });
  });
  root.querySelectorAll('.clair__thumb').forEach(function (t) {
    t.addEventListener('click', function () { if (hero) { hero.removeAttribute('srcset'); hero.src = t.dataset.full; } if (overlay) overlay.hidden = true; });
  });
  var stage = root.querySelector('.clair__stage');
  if (stage) {
    var setOrigin = function (cx, cy) {
      var r = stage.getBoundingClientRect();
      var x = Math.max(0, Math.min(1, (cx - r.left) / r.width)) * 100;
      var y = Math.max(0, Math.min(1, (cy - r.top) / r.height)) * 100;
      stage.style.setProperty('--zx', x + '%'); stage.style.setProperty('--zy', y + '%');
    };
    stage.addEventListener('mouseenter', function () { stage.classList.add('is-zooming'); });
    stage.addEventListener('mousemove', function (e) { setOrigin(e.clientX, e.clientY); });
    stage.addEventListener('mouseleave', function () { stage.classList.remove('is-zooming'); });
    stage.addEventListener('touchstart', function (e) { stage.classList.add('is-zooming'); var t = e.touches[0]; setOrigin(t.clientX, t.clientY); }, { passive: true });
    stage.addEventListener('touchmove', function (e) { var t = e.touches[0]; setOrigin(t.clientX, t.clientY); }, { passive: true });
    stage.addEventListener('touchend', function () { stage.classList.remove('is-zooming'); });
  }
  root.querySelectorAll('.clair__dot').forEach(function (d) {
    d.addEventListener('click', function () {
      // aria-pressed has to move with is-sel. A selected state that only exists
      // as a box-shadow is invisible to anyone not looking at the screen, and a
      // static aria-pressed that never updates is worse than none at all.
      root.querySelectorAll('.clair__dot').forEach(function (x) {
        x.classList.remove('is-sel'); x.setAttribute('aria-pressed', 'false');
      });
      d.classList.add('is-sel'); d.setAttribute('aria-pressed', 'true');
      setSelected(d.getAttribute('title'), d.dataset.available !== 'false',
                  parseInt(d.dataset.qty || '0', 10), d.dataset.trk === 'true');
      applyExample(d.dataset.cw, d.dataset.ph === 'true', d.dataset.img);
      if (d.dataset.img && hero) { hero.dataset.skein = d.dataset.img; }
      var idInput = root.querySelector('.clair__form input[name=id]');
      if (idInput && d.dataset.variant) { idInput.value = d.dataset.variant; }
      var avail = d.dataset.available !== 'false';
      var addBtn = root.querySelector('.clair__add');
      var notify = root.querySelector('.clair__notify');
      // Sold out is a lead time, not a refusal — but only while custom dye is
      // switched ON and this variant is actually dyeable. These two lines used
      // to run unconditionally, which meant flipping the setting off still left
      // the button live and the back-in-stock form hidden, and the resulting
      // order carried no property at all: worse than either state the merchant
      // was choosing between.
      // Dyeability is PER VARIANT, not per page: 13 active yarn products carry
      // both CONTINUE and DENY variants side by side (Big Merino, Cashmerino
      // 50g, Wheel of the Year and friends), so a page-wide flag would offer to
      // dye a one-of-a-kind skein sitting in the same swatch grid as ordinary
      // colourways.
      var canDye = dyeOn && d.dataset.dyeable !== 'false';
      if (addBtn) {
        addBtn.disabled = !(avail || canDye);
        addBtn.style.display = (avail || canDye) ? '' : 'none';
      }
      if (notify) { notify.hidden = avail || canDye || d.dataset.norestock === 'true'; }   // never restocked: no form
      root.dataset.norestock = String(d.dataset.norestock === 'true');                      // and no app button (CSS below)
      setDto(!avail && canDye);
      var nb = root.querySelector('.clair__notify-body');
      if (nb) { nb.value = 'Back-in-stock request: ' + (nb.dataset.bodyBase || '') + ' — ' + (d.getAttribute('title') || ''); }
    });
  });

  // ── option-aware variant resolution: chip rows (base + any non-colour option) × colour ──
  (function () {
    var vmapEl = root.querySelector('[data-clair-variants]');
    var optnamesEl = root.querySelector('[data-clair-optnames]');
    if (!vmapEl || !optnamesEl) return;
    var VARIANTS, OPTNAMES;
    try { VARIANTS = JSON.parse(vmapEl.textContent || '[]'); OPTNAMES = JSON.parse(optnamesEl.textContent || '[]'); } catch (e) { return; }
    if (!VARIANTS.length) return;
    // These two lists MUST stay in step with the Liquid matcher at the top of
    // this section. They did not: Liquid matched eight spellings, this matched
    // two, so a product whose option is named "Couleur" — Haku, Chihiro & No
    // Face, Nausicaa — rendered a swatch grid from Liquid that this code then
    // failed to recognise (/colo/ does not match "couleur"), leaving colourIdx
    // at -1 and the base chips uncoordinated with the selected colour.
    var colourIdx = OPTNAMES.findIndex(function (n) { return /colo|coul|teinte|farb|farve|kleur|colore|色/i.test(n); });
    // Engage when there is a chip row to drive: the base row, or the row Liquid
    // renders for any other option (Length, Size, Material…). Each chip carries
    // the index of the option it sets in data-idx.
    var chips = root.querySelectorAll('.clair__base[data-idx]');
    if (!chips.length) return;
    var idInput = root.querySelector('.clair__form input[name=id]');
    var addBtn = root.querySelector('.clair__add');
    var notify = root.querySelector('.clair__notify');
    var selName = root.querySelector('[data-selected]');
    var cur = VARIANTS.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0]
            || VARIANTS.filter(function (v) { return v.avail; })[0] || VARIANTS[0];
    var selectedOpts = cur ? cur.opts.slice() : [];
    function findVariant() {
      return VARIANTS.filter(function (v) {
        return v.opts.every(function (o, i) { return selectedOpts[i] == null || o === selectedOpts[i]; });
      })[0];
    }
    function refreshBases() {
      chips.forEach(function (chip) {
        var k = +chip.dataset.idx, bval = chip.dataset.base;
        // Struck through = cannot be bought in this COLOUR at all. Checking the
        // other chip rows too crossed out every size missing from the current
        // length, which reads as sold out when one click would reach it.
        var anyAvail = VARIANTS.some(function (v) {
          return v.opts[k] === bval && v.avail && (colourIdx < 0 || colourIdx === k || selectedOpts[colourIdx] == null || v.opts[colourIdx] === selectedOpts[colourIdx]);
        });
        chip.classList.toggle('is-sel', bval === selectedOpts[k]);
        chip.setAttribute('aria-pressed', bval === selectedOpts[k] ? 'true' : 'false');
        chip.classList.toggle('is-out', !anyAvail);
      });
    }
    function applySelection() {
      var v = findVariant();
      refreshBases();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      // The skein estimator divides by YARDS PER SKEIN, and that is a property
      // of the base, not of the colourway. Changing base has to move it or the
      // answer is silently wrong — Bon Bon in Silk Tweed was told "about 2
      // skeins" for a sweater needing about 8, because 710 (Alix) was used for
      // all eight bases.
      var calcEl = root.querySelector('.clair__calc');
      if (calcEl && v.yd) {
        calcEl.dataset.skeinYardage = v.yd;
        // The project OPTIONS are yardages, and they are per base too: the
        // weight factor differs, and Aimée's sweater_skeins override replaces
        // it outright. Rebuild them from the base ratios so switching base
        // moves the whole picker, not just the divisor.
        if (v.yf) {
          var RATIO = [230, 400, 400, 800, 1200];
          var opts = calcEl.querySelectorAll('.clair__project option');
          var oi = 0;
          opts.forEach(function (o) {
            if (!o.value) return;                       // the "choose…" row
            if (oi < RATIO.length) o.value = Math.round(RATIO[oi] * v.yf / 100);
            oi++;
          });
        }
        var sel = root.querySelector('.clair__project');
        if (sel && sel.value) sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      // This block predates dye-to-order and used to hide the buy button and
      // bring the notify form back whenever a variant was out of stock — which
      // silently switched the whole feature off on the 24 products that have a
      // Base option, 18 of which have a sold-out variant right now. Worse, on
      // those products BOTH this and the generic swatch handler fire on one
      // click, and this one runs second, so it undid the correct state even for
      // a plain colour choice. It now defers to the same setDto the rest of the
      // section uses, so there is one authority instead of two fighting.
      var canDye = dyeOn && v.dye !== false;
      if (addBtn) {
        addBtn.disabled = !(v.avail || canDye);
        addBtn.style.display = (v.avail || canDye) ? '' : 'none';
      }
      if (notify) notify.hidden = v.avail || canDye || !!v.nr;
      root.dataset.norestock = String(!!v.nr);
      // The over-stock check reads these: which variant is selected, whether it can be dyed, how many are on the shelf.
      root.dataset.selDye = String(v.dye !== false);
      root.dataset.selQty = String(v.qty || 0);
      root.dataset.selTrk = String(!!v.trk);
      if (typeof root.__clairSetDto === 'function') root.__clairSetDto(!v.avail && canDye);
      setSelected(v.title, v.avail, v.qty, v.trk);
      root.querySelectorAll('[data-dyelot]').forEach(function (el) { el.hidden = (el.dataset.dyelot === 'mill') !== !!v.mill; });
      if (v.img && hero) { hero.removeAttribute('srcset'); hero.src = v.img; if (overlay) overlay.hidden = true; }
      if (selName && colourIdx < 0) selName.textContent = v.title;
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var k = +chip.dataset.idx;
        selectedOpts[k] = chip.dataset.base;
        // Not every combination exists (a 2 mm tip may come in 23 cm only).
        // Rather than leave the form holding the PREVIOUS variant — which is
        // what an unmatched click used to do, silently — move the other
        // options to the first variant that has this value, in stock first.
        if (!findVariant()) {
          var pool = VARIANTS.filter(function (v) { return v.opts[k] === selectedOpts[k]; });
          var hit = pool.filter(function (v) { return v.avail; })[0] || pool[0];
          if (hit) selectedOpts = hit.opts.slice();
        }
        applySelection();
      });
    });
    root.querySelectorAll('.clair__dot').forEach(function (d) {
      d.addEventListener('click', function () {
        var hit = VARIANTS.filter(function (v) { return String(v.id) === String(d.dataset.variant); })[0];
        if (hit) { selectedOpts = hit.opts.slice(); applySelection(); }
      });
    });
    applySelection();
  })();

  var qty = root.querySelector('.clair__qty');
  var addLabel = root.querySelector('[data-tpl-add]');
  var hint = root.querySelector('.clair__qtyhint');
  function updateAddLabel(n) { if (!addLabel) return; if (n > 1 && addLabel.dataset.tplAdd) { addLabel.textContent = addLabel.dataset.tplAdd.replace('[n]', n); } else { addLabel.textContent = addLabel.dataset.plain || addLabel.textContent; } }
  function computeHint(n) {
    if (!hint) return;
    var yard = parseInt(hint.dataset.yardage, 10) || 400, total = n * yard, label = '';
    var sel = root.querySelector('.clair__project');
    if (sel) {
      var opts = Array.prototype.slice.call(sel.options).map(function (o) { return { y: parseInt(o.value, 10) || 0, t: o.textContent }; }).filter(function (o) { return o.y > 0; }).sort(function (a, b) { return b.y - a.y; });
      for (var i = 0; i < opts.length; i++) { if (total >= opts[i].y) { label = opts[i].t; break; } }
    }
    if (!label) label = hint.dataset.small || '';
    hint.textContent = label ? ('✦ ' + (hint.dataset.enough || 'Enough for') + ' ' + label) : '';
  }
  // Assigning .value fires no input event, so every caller of this used to move
  // the quantity past what is on the shelf without the dye-to-order flag ever
  // being recomputed. That is precisely what the skein calculator exists to do:
  // pick "Sweater", get 6, when 3 are in stock. Refresh here, at the one place
  // quantity actually changes, rather than on each caller.
  function setQty(n) {
    n = Math.max(1, parseInt(n, 10) || 1);
    if (qty) qty.value = n;
    updateAddLabel(n); computeHint(n);
    if (typeof root.__clairRefreshOver === 'function') root.__clairRefreshOver();
  }
  root.querySelectorAll('.clair__step').forEach(function (s) { s.addEventListener('click', function () { var v = qty ? (parseInt(qty.value, 10) || 1) : 1; setQty(v + (parseInt(s.dataset.step, 10) || 0)); setQtySource(''); }); });
  if (qty) qty.addEventListener('input', function () { var n = parseInt(qty.value, 10) || 1; updateAddLabel(n); computeHint(n); setQtySource(''); });
  var qtySrc = root.querySelector('[data-qty-source]');
  function setQtySource(src) { if (!qtySrc) return; qtySrc.value = src || ''; qtySrc.disabled = !src; }
  var soloIns = root.querySelector('.clair__solo-insurance');
  if (soloIns) soloIns.addEventListener('change', function () { var n = qty ? (parseInt(qty.value, 10) || 1) : 1; setQty(soloIns.checked ? n + 1 : Math.max(1, n - 1)); setQtySource(soloIns.checked ? 'insurance skein' : ''); });
  var calc = root.querySelector('.clair__calc');
  if (calc) {
    // Re-read on every use, never cache: applySelection() rewrites
    // data-skein-yardage when the shopper changes BASE, and a cached value
    // would keep dividing a Silk Tweed project by Alix's 710 yards.
    var skein = parseInt(calc.dataset.skeinYardage, 10) || 400;
    var proj = calc.querySelector('.clair__project');
    var ins = calc.querySelector('.clair__insurance');
    var res = calc.querySelector('.clair__calc-result');
    var recompute = function () {
      var need = parseInt(proj.value, 10) || 0;
      if (!need) { if (res) res.textContent = res.dataset.prompt || ''; setQtySource(''); return; }
      var n = Math.max(1, Math.ceil(need / skein));
      if (ins && ins.checked) { n += 1; }
      setQtySource(ins && ins.checked ? 'calculator + insurance skein' : 'calculator');
      if (res) {
        var tpl = (n === 1 && res.dataset.tplOne) ? res.dataset.tplOne
                                                  : (res.dataset.tpl || 'About [n] skeins');
        res.textContent = tpl.replace('[n]', n);
      }
      setQty(n);
    };
    if (proj) proj.addEventListener('change', recompute);
    if (ins) ins.addEventListener('change', recompute);
  }
  computeHint(qty ? (parseInt(qty.value, 10) || 1) : 1);
});
(function () {
  document.querySelectorAll('[data-recs]').forEach(function (el) {
    if (!el.dataset.url) return;
    var extra = el.querySelector('template[data-recs-extra]');
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var c = new DOMParser().parseFromString(html, 'text/html').querySelector('.cc-recs');
      if (!c) return;
      el.innerHTML = c.outerHTML;
      /* Category tiles fill the slots a short manual list leaves empty. */
      var grid = extra && el.querySelector('.cc-recs__grid');
      if (grid) grid.appendChild(extra.content.cloneNode(true));
    }).catch(function () {});
  });
})();

  /* Colour grid overflow. The grid renders every variant; this collapses it to
     the first 24 and turns the "+N more" button on. Doing it here rather than in
     Liquid means a shopper without JS sees all the swatches instead of a dead
     control and 105 unreachable colourways. */
  document.querySelectorAll('.clair__dots').forEach(function (grid) {
    // Three things bit while building this, all worth keeping written down:
    //   * this runs in its own forEach — `root` from the product IIFE is NOT in
    //     scope, and referencing it threw a ReferenceError that silently killed
    //     the collapse as well as the panel;
    //   * Shopify always preselects a variant, so gating the panel on "is
    //     anything selected" meant it could never appear. Gate on the URL
    //     naming a variant — the only signal the shopper chose one;
    //   * the gate is ONE class on the grid, never `hidden` on 70 buttons. The
    //     family filter already hides dots with .clair__dot--hid, and two
    //     mechanisms fighting left the grid empty when a family was picked.
    var ff = grid.querySelector('[data-clair-ff]');
    // The "Show all" button is NOT inside this grid — it sits in a sibling
    // .clair__dots--tail div, so grid.querySelector() found nothing and
    // collapse() bailed on `!btn` every single time. The feature had never
    // worked, on this branch or on main. Look it up from the wrapper that
    // holds both. Grids with no overflow still skip out on `!extra.length`,
    // so the sold-out and tail grids are unaffected.
    var wrapEl = grid.closest('.clair__swatches') || grid.parentNode;
    var btn = wrapEl ? wrapEl.querySelector('[data-clair-more]') : null;
    var extra = grid.querySelectorAll('.clair__dot--extra');

    var collapse = function () {
      if (!btn || !extra.length) return;
      // With the In stock | Dye to order tabs the in-stock grid is short enough to show whole:
      // landing, clicking All and seeing 15 tiles plus a "show all" button read as a bug (Matthew, 2026-09-14).
      if (document.querySelector('[data-clair-tabs]')) { btn.hidden = true; return; }
      var selHidden = false;
      extra.forEach(function (d) { if (d.classList.contains('is-sel')) selHidden = true; });
      if (selHidden) return;                       // never collapse over the selected swatch
      grid.classList.add('is-collapsed');
      btn.hidden = false;
      btn.setAttribute('aria-expanded', 'false');
    };
    if (btn) {
      btn.addEventListener('click', function () {
        grid.classList.remove('is-collapsed');
        btn.setAttribute('aria-expanded', 'true');
        btn.hidden = true;
        var first = grid.querySelector('.clair__dot--extra');
        if (first) first.focus();
      });
    }

    if (grid.hasAttribute('data-family-first') && ff && !/[?&]variant=/.test(location.search)) {
      var openGrid = function () {
        grid.removeAttribute('data-family-first');
        grid.classList.remove('is-gated');
        ff.hidden = true;
        collapse();
      };
      ff.hidden = false;
      grid.classList.add('is-gated');
      var seeAll = ff.querySelector('[data-clair-seeall]');
      if (seeAll) seeAll.addEventListener('click', openGrid);
      var fams = document.querySelector('[data-clair-fams]');
      if (fams) {
        fams.addEventListener('click', function (e) {
          if (e.target.closest('[data-fam-pick]')) openGrid();
        }, { once: true });
      }
      return;
    }
    collapse();
  });

  /* Sold-out colourways. Hidden by default because 46% of Kumo's grid was
     unbuyable, but kept reachable: none of them are retired - each is in stock
     on another base today, so the group is a cross-sell, not a graveyard. */
  /* Lite mode. A browser cannot see the GPU, but it can see memory and cores, and the person can ask
     for reduced motion. On any of those the page drops its blur filter and its animations — the two
     things here that make a weak phone stutter — and keeps everything else. */
  (function () {
    var weak = (navigator.deviceMemory && navigator.deviceMemory <= 2) || (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 2);
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (weak || still) document.documentElement.classList.add('lba-lite');
  })();
  /* Tile photos load only as they scroll into view — 144 requests at page load became a few dozen.
     On a data-saver or 2G connection they stay as colour chips until the shopper taps one. */
  (function () {
    var conn = navigator.connection || {};
    var frugal = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
    function load(t) { if (t.dataset.tile && !t.classList.contains('is-loaded')) { t.style.backgroundImage = 'url(' + t.dataset.tile + ')'; t.classList.add('is-loaded'); } }
    var tiles = document.querySelectorAll('.clair__tile[data-tile]');
    if (!('IntersectionObserver' in window)) { tiles.forEach(load); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { if (!frugal) load(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '240px 0px' });
    tiles.forEach(function (t) { io.observe(t); });
    document.addEventListener('click', function (e) { var d = e.target.closest('.clair__dot'); if (d) { var t = d.querySelector('.clair__tile[data-tile]'); if (t) load(t); } }, true);
  })();
  document.querySelectorAll('[data-clair-tabs]').forEach(function (tabs) {
    var host = tabs.parentElement;
    var panels = { stock: host.querySelector('[data-tab-panel="stock"]'), dto: host.querySelector('[data-tab-panel="dto"]') };
    var KEY = 'lba:colour-tab';
    function show(which) {
      tabs.querySelectorAll('.clair__tab').forEach(function (b) { var on = b.dataset.tab === which; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
      Object.keys(panels).forEach(function (k) { if (panels[k]) panels[k].hidden = (k !== which); });
      try { localStorage.setItem(KEY, which); } catch (e) {}
    }
    tabs.addEventListener('click', function (e) { var b = e.target.closest('.clair__tab'); if (b) show(b.dataset.tab); });
    var saved = null; try { saved = localStorage.getItem(KEY); } catch (e) {}
    var stockEmpty = panels.stock && !panels.stock.querySelector('.clair__dot');
    /* Desktop shows five tiles a row, so a hundred colourways is a short scroll: one grid, the
       dye-to-order group under its header bar (Baymard: never hide buyable options). A phone shows
       three a row and forty rows, so there the tabs earn their click. "auto" decides by width;
       the section setting can force either. */
    var wide = window.matchMedia ? window.matchMedia('(min-width: 750px)') : null;
    function layout() {
      var mode = tabs.dataset.layout || 'auto';
      if (mode === 'auto') mode = (wide && wide.matches) ? 'inline' : 'tabs';
      if (mode === 'inline') { tabs.hidden = true; Object.keys(panels).forEach(function (k) { if (panels[k]) panels[k].hidden = false; }); host.classList.add('is-inline'); }
      else { tabs.hidden = false; host.classList.remove('is-inline'); show(stockEmpty ? 'dto' : (saved === 'dto' ? 'dto' : 'stock')); }
    }
    layout();
    if (wide && wide.addEventListener) wide.addEventListener('change', layout);
  });
  document.querySelectorAll('[data-clair-oos]').forEach(function (btn) {
    if (document.querySelector('[data-clair-tabs]')) return;   // tabs own the panels now
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var KEY = 'lba:oos-open';
    function paint(open) {
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      // the label has to change, or once expanded there is no visible way back
      var t = open ? btn.getAttribute('data-hide') : btn.getAttribute('data-show');
      if (t) btn.textContent = t;
    }
    // a shopper who wants to see sold-out colours on one yarn wants it on the
    // next one too; remember it rather than making them re-open it every time
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    paint(saved === '1');
    btn.addEventListener('click', function () {
      var open = panel.hidden;
      paint(open);
      try { localStorage.setItem(KEY, open ? '1' : '0'); } catch (e) {}
    });
  });

  /* Price follows the selected variant (data-clair-prices, rendered beside the price). Registered
     BEFORE the phone add bar so its own click handler reads the updated price. */
  (function () {
    var pel = document.querySelector('[data-clair-prices]');
    var vid = document.querySelector('.clair__form input[name=id]');
    var nowEl = document.querySelector('.clair__price-now');
    if (!pel || !vid || !nowEl) return;
    var P; try { P = JSON.parse(pel.textContent || '{}'); } catch (e) { return; }
    function sync() {
      var e = P[vid.value]; if (!e) return;
      nowEl.innerHTML = e[0];
      var was = document.querySelector('.clair__price-was');
      if (e[1]) {
        if (!was) { was = document.createElement('s'); was.className = 'clair__price-was'; nowEl.insertAdjacentElement('afterend', was); }
        was.innerHTML = e[1];
      } else if (was) { was.remove(); }
      var sb = document.querySelector('[data-stickybar-price]'); if (sb) sb.textContent = nowEl.textContent.trim();
    }
    document.addEventListener('click', function (ev) {
      if (ev.target.closest('.clair__dot, .clair__base')) setTimeout(sync, 0);
    });
  })();

  /* Phone add bar: mirrors the real button whenever that button is off-screen. */
  (function () {
    var bar = document.querySelector('[data-stickybar]');
    var add = document.querySelector('.clair__add');
    if (!bar || !add || !('IntersectionObserver' in window)) return;
    var nameEl = bar.querySelector('[data-stickybar-name]'), priceEl = bar.querySelector('[data-stickybar-price]'), btn = bar.querySelector('[data-stickybar-btn]');
    var offscreen = false;
    function refresh() {
      var usable = !add.disabled && getComputedStyle(add).display !== 'none';
      bar.hidden = !(offscreen && usable);
      document.documentElement.classList.toggle('has-stickybar', !bar.hidden);
      if (bar.hidden) return;
      var lbl = add.querySelector('span'); if (lbl && btn) btn.textContent = lbl.textContent.trim();
      var sel = document.querySelector('[data-selected-name]'); if (sel && nameEl && sel.textContent.trim()) nameEl.textContent = sel.textContent.trim();
      var pr = document.querySelector('.clair__price-now'); if (pr && priceEl) priceEl.textContent = pr.textContent.trim();
    }
    new IntersectionObserver(function (es) { es.forEach(function (e) { offscreen = !e.isIntersecting; }); refresh(); }, { threshold: 0 }).observe(add);
    document.addEventListener('click', function (e) { if (e.target.closest('.clair__dot, .clair__base, [data-fam-pick], .clair__tab, .clair__step')) setTimeout(refresh, 0); });
    // the real button's label changes with the quantity and the calculator; mirror every change
    if ('MutationObserver' in window) new MutationObserver(function () { if (!bar.hidden) refresh(); }).observe(add, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'style'] });
    if (btn) btn.addEventListener('click', function () { add.click(); });
  })();

  /* Colour-family filtering. Everything is already in the DOM, so this is pure
     show/hide - no request, no reflow of the page. Picking a family also lifts
     the 24-swatch collapse, because a filtered set is small enough to show
     whole; clearing the filter restores it. */
  document.querySelectorAll('[data-clair-fams]').forEach(function (bar) {
    var wrap = bar.parentNode;
    var grid = wrap.querySelector('.clair__dots');
    if (!grid) return;
    var more = wrap.querySelector('[data-clair-more]');
    var chips = bar.querySelectorAll('[data-fam-pick]');
    var wasCollapsed = false;
    /* Find by name: accent-insensitive substring match on the colourway title. */
    var find = wrap.querySelector('[data-clair-find]'), findNone = wrap.querySelector('[data-clair-find-none]');
    var fold = function (t) { return (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); };
    var findLifted = false, findWasCollapsed = false;
    if (find) find.addEventListener('input', function () {
      var q = fold(find.value).trim(), n = 0, hiddenHit = null;
      if (q && !findLifted) {
        findLifted = true; findWasCollapsed = grid.classList.contains('is-collapsed');
        grid.classList.remove('is-collapsed'); grid.classList.remove('is-gated');
        var ff = grid.querySelector('[data-clair-ff]'); if (ff) ff.hidden = true;
        if (more) more.hidden = true;
      }
      if (!q && findLifted) {
        // box emptied: put the 24-tile collapse back the way it was
        findLifted = false;
        if (findWasCollapsed) { grid.classList.add('is-collapsed'); if (more) { more.hidden = false; more.setAttribute('aria-expanded', 'false'); } }
      }
      wrap.querySelectorAll('.clair__dots .clair__dot').forEach(function (d) {
        var hit = !q || fold(d.getAttribute('data-cw') || d.getAttribute('title')).indexOf(q) > -1;
        d.classList.toggle('clair__dot--nomatch', !hit);
        if (!hit || !q || d.classList.contains('clair__dot--hid')) return;
        var panel = d.closest('[data-tab-panel]');
        if (panel && panel.hidden) { if (!hiddenHit) hiddenHit = panel; } else n++;
      });
      // the only matches sit under the other tab (phones): open that tab rather than show nothing
      if (q && n === 0 && hiddenHit) {
        var tab = document.querySelector('.clair__tab[data-tab="' + hiddenHit.getAttribute('data-tab-panel') + '"]');
        if (tab) { tab.click(); n = 1; }
      }
      if (findNone) findNone.hidden = !(q && n === 0);
    });
    bar.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-fam-pick]');
      if (!chip) return;
      var pick = chip.getAttribute('data-fam-pick');
      chips.forEach(function (c) {
        c.classList.toggle('is-sel', c === chip);
        c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
      });
      if (pick) {
        if (grid.classList.contains('is-collapsed')) { wasCollapsed = true; grid.classList.remove('is-collapsed'); }
        if (more) more.hidden = true;
      } else if (wasCollapsed) {
        grid.classList.add('is-collapsed');
        if (more) { more.hidden = false; more.setAttribute('aria-expanded', 'false'); }
      }
      // both panels: the in-stock grid and the dye-to-order grid share the chips
      wrap.querySelectorAll('.clair__dots .clair__dot').forEach(function (d) {
        // The selected swatch used to be force-shown under EVERY filter, so a
        // shopper would not lose their own choice. It solved that and created
        // something worse: Kumo opens on Acajou, so filtering to Yellow listed
        // "Acajou, Buzz, Sunburst, Yellow Brick Road" — a mahogany brown filed
        // correctly as brown, sitting in the yellow filter, on every product
        // whose default variant is not the colour being filtered for.
        //
        // It is safe to drop now because the selection is no longer only
        // visible as a swatch: the line above the grid carries its name and
        // its stock ("Acajou · 2 in stock", aria-live), and the add-to-cart
        // still holds that variant. Nothing is lost by letting the filter mean
        // what it says.
        var fam = (d.getAttribute('data-fam') || '');
        d.classList.toggle('clair__dot--hid', !!pick && fam.split(',').indexOf(pick) === -1);
      });
    });
  });

  /* After a back-in-stock signup, return the shopper to what they CAN buy.
     Leaving them parked in the sold-out shelf ends the visit on a dead end;
     collapsing back to the in-stock grid is the "then shop for real" step. */
  document.querySelectorAll('.clair__notify form').forEach(function (f) {
    f.addEventListener('submit', function () {
      try { localStorage.setItem('lba:oos-open', '0'); } catch (e) {}
    });
  });
  (function () {
    var ok = document.querySelector('.clair__notify-ok');
    if (!ok) return;
    var btn = document.querySelector('[data-clair-oos]');
    if (btn && btn.getAttribute('aria-expanded') === 'true') btn.click();
    ok.scrollIntoView({ block: 'center', behavior: 'smooth' });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search-clair"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.cc'); if (!root) return;
  var input = root.querySelector('[data-ac]'); var box = root.querySelector('[data-ac-box]');
  if (!input || !box) return;
  var timer, last = '';
  var esc = function (s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  // This locale's suggest endpoint (it used to be the ROOT one, which sent French, German and Danish shoppers to English
  // pages). ja, ko and zh-TW answer 417 "Unsupported buyer locale": fall back to the root endpoint for the
  // rest of the page view and move its links under this locale. knowledge/search-multilingual-plan-2026-10-21.md
  var acUrl = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
  var acRoot = acUrl.replace(/\/search\/suggest$/, '');
  var useRoot = false;
  function localise(u) { return acRoot && u && u.charAt(0) === '/' && u.indexOf(acRoot + '/') !== 0 ? acRoot + u : u; }
  function suggest(base, q) { return fetch(base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,query,collection&resources[limit]=6&resources[options][unavailable_products]=last'); }
  function hide() { box.hidden = true; }
  function run() {
    var q = input.value.trim();
    if (q.length < 2) { hide(); box.innerHTML = ''; return; }
    if (q === last && box.innerHTML) { box.hidden = false; return; }
    last = q;
    suggest(useRoot ? '/search/suggest' : acUrl, q)
      .then(function (r) {
        if (r.status === 417 && !useRoot) { useRoot = true; console.warn('[search-ac] 417 from ' + acUrl + '; using the root suggestions'); return suggest('/search/suggest', q); }
        return r;
      })
      .then(function (r) { if (!r.ok) throw new Error('suggest ' + r.status); return r.json(); }).then(function (d) {
        var r = (d.resources && d.resources.results) || {}; var h = '';
        (r.queries || []).slice(0, 4).forEach(function (x) { h += '<a class="cc__sg cc__sg--q" href="' + esc(localise(x.url)) + '">&#9906; ' + esc(x.text) + '</a>'; });
        (r.products || []).forEach(function (p) { var img = (p.featured_image && p.featured_image.url) || p.image || ''; h += '<a class="cc__sg" href="' + esc(localise(p.url)) + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span class="cc__sg-ph"></span>') + '<span class="cc__sg-t">' + esc(p.title) + '</span></a>'; });
        // Root collections carry English titles, so they are left out when the root endpoint answered.
        if (!useRoot) (r.collections || []).slice(0, 3).forEach(function (c) { h += '<a class="cc__sg cc__sg--col" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; });
        box.innerHTML = h; box.hidden = !h;
      }).catch(function (e) { console.warn('[search-ac] suggestions failed', e); hide(); });
  }
  input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 160); });
  input.addEventListener('focus', function () { if (box.innerHTML) box.hidden = false; });
  input.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
  document.addEventListener('click', function (e) { if (!e.target.closest('.cc__acwrap')) hide(); });
})();

  } catch(e) { console.error(e); }
})();
})();
